import MapMenu from '../lib/map_menu';

export default class LibraryLayer {
	constructor() {
		this.checkboxEl = document.getElementById('libraries-layer');
		this.visible = false;
	}

	add(map) {
		const url = W.api_root + 'libraries/locations';
		if (!map.getSource('libraries-source')) {
			map.addSource('libraries-source', {
				type: 'geojson',
				data: url,
			});
		}

		map.addLayer({
			id: 'libraries-layer',
			type: 'symbol',
			source: 'libraries-source',
			layout: {
				'icon-image': 'marker-library',
				'icon-offset': [0, 0],
				'icon-anchor': 'bottom',
				'icon-size': 1.5,
				'icon-allow-overlap': true,
				'icon-ignore-placement': true,
			},
		});
		this.visible = true;
		W.LayerUtils.setView('libraries-layer');
		MapMenu.hide();
	}

	remove() {
		W.map.removeLayer('libraries-layer');
		this.visible = false;
	}
}
